// middleware/auth.global.ts
export default defineNuxtRouteMiddleware((to, from) => {
  const { loggedIn } = useUserSession()
  if (!loggedIn.value && (to.path.startsWith('/my-account') || to.path.startsWith('/cart') || to.path.startsWith('/checkout'))) {
    return navigateTo('/error-401')
  }
})
